import $ from 'jquery';
import React from 'react';
import update from 'immutability-helper';
import NewRepForm from './NewRepForm.js';

class NewRepFormContainer extends React.Component {
  state = {
    errors: {},
    failed: false,
    params: {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      birthdate: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      shirtSize: '',
      facebookProfileUrl: '',
      instagramProfileUrl: '',
      linkedinProfileUrl: '',
      twitterProfileUrl: '',
      positionTypes: [],
      childrenSports: '',
      currentlyCoaching: false,
      excites: '',
      fundraisingExperience: '',
      // lawEnforcement: false,
      // lawEnforcementRetired: false,
      // lawEnforcementAgency: '',
      mySchedule: '',
      salesExperience: undefined,
      salesExperienceDescription: '',
      sportCoached: '',
      sportPlayed: '',
      sportTrained: '',
      teamManagementUsed: '',
      teamRelationships: '',
      techRatingAndroid: '',
      techRatingFacebook: '',
      techRatingGofundme: '',
      techRatingGoogleSheets: '',
      techRatingIphone: '',
      techRatingKickstarter: '',
      techRatingLinkedIn: '',
      techRatingShutterfly: '',
      techRatingSnapchat: '',
      techRatingTeamsnap: '',
      techRatingTikTok: '',
      techRatingTwitter: '',
      techRatingYoutube: '',
      whyIsBlastBetter: '',
      willingToColdCall: undefined,
      willingToNetwork: undefined,
      willingToUseBlastFundraising: undefined,
      workedFromHome: undefined,
    },
    submitting: false,
    submissions: 0,
    successful: false,
  };

  _changeParam = (key, value) => {
    this.setState(prev => {
      return {
        params: update(prev.params, {$merge: {[key]: value}}),
      };
    });
  };

  _toggleParam = (key) => {
    this.setState(prev => {
      return {
        params: update(prev.params, {$toggle: [key]}),
      };
    });
  };

  _submit = (event) => {
    event.preventDefault();
    if (this.state.submitting) {
      return;
    }
    this.setState({errors: {}, failed: false, submitting: true});
    $.postJSON(this.props.submitUrl, {rep_application: this.state.params}).done(data => {
      window.location.href = data.redirect_to;
    }).fail(jqXHR => {
      if (jqXHR.status === 422) {
        const errors = JSON.parse(jqXHR.responseText);
        this.setState(prev => {
          return {
            errors: errorsFromServer(errors),
            failed: true,
            submitting: false,
            submissions: prev.submissions + 1,
          };
        });
      } else {
        this.setState(prev => {
          return {
            failed: true,
            submitting: false,
            submissions: prev.submissions + 1,
          };
        });
      }
    });
  };

  render() {
    if (!this.state.successful) {
      return (
        <NewRepForm
          errors={this.state.errors}
          failed={this.state.failed}
          params={this.state.params}
          submitting={this.state.submitting}
          submissionCount={this.state.submissions}
          onParamChanged={this._changeParam}
          onParamToggled={this._toggleParam}
          onSubmit={this._submit} />
      );
    }
    return (
      <div>
        <p>
          Your application has been received.
        </p>
      </div>
    );
  }
}

export default NewRepFormContainer;

export function errorsFromServer(errors) {
  return {
    firstName: errors.first_name && errors.first_name[0],
    lastName: errors.last_name && errors.last_name[0],
    phone: errors.phone && errors.phone[0],
    email: errors.email && errors.email[0],
    birthdate: errors.birthdate && errors.birthdate[0],
    address1: errors.address1 && errors.address1[0],
    address2: errors.address2 && errors.address2[0],
    city: errors.city && errors.city[0],
    state: errors.state && errors.state[0],
    zip: errors.zip && errors.zip[0],
    shirtSize: errors.shirt_size && errors.shirt_size[0],
    positionTypes: errors.position_types && errors.position_types[0],
  };
}
